module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-left-1.19858750.png";